import { render, staticRenderFns } from "./TiktokMedia.vue?vue&type=template&id=35b37789&"
import script from "./TiktokMedia.vue?vue&type=script&lang=js&"
export * from "./TiktokMedia.vue?vue&type=script&lang=js&"
import style0 from "./TiktokMedia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports